module.exports = "<md-content layout-padding>\r\n    <md-progress-circular md-mode=\"indeterminate\" ng-show=\"vm._isLoading\"></md-progress-circular>\r\n    <div class=\"md-whiteframe-z1\" ng-repeat=\"idx in vm.pageindices\" style=\"display:inline-block\">\r\n        <crewpdfviewersinglepage pageindex=\"::idx\" scale=\"vm.scale\" pdf=\"::vm.pdf\"></crewpdfviewersinglepage>\r\n    </div>\r\n</md-content>"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/crewpdfviewer.html
// module id = 1239
// module chunks = 1